import { useAuth } from "@/auth";
import { api } from "@/utils/api";
import { toast } from "sonner";
import { Button } from "../generic/Button";
import { Heading } from "../generic/Heading";

export const EmptyCustomFilter = () => {
  const { user } = useAuth();

  const postContactInfo = () => {
    const contactInfo = {
      page: "Lasso Sales: Egne Filtre",
      name: user.name,
      email: user.email,
      phone: user.phoneNumber,
      message:
        "Jeg ønsker at blive kontaktet vedr. mulighederne med egne filtre, e.g. AI filtre.",
      partnerType: null,
      companyName: user.organization.name,
      supportSubject:
        'Ønsker at blive kontakted ved. "egne filtre" i Lasso Sales',
      support: false,
    };

    if (import.meta.env.PROD) {
      api.post("contact/contact", {
        json: contactInfo,
      });
    } else {
      console.info("[DRY RUN] POST: /contact/contact", contactInfo);
    }

    toast("Tak - du bliver kontaktet af os hurtigst muligt", {
      description: !import.meta.env.PROD
        ? "Besked ikke sendt i udviklingsmiljø. Tjek konsollen."
        : undefined,
    });
  };

  return (
    <div className="mt-3 flex h-full flex-col items-center justify-center gap-y-20">
      <div className="mx-auto flex h-full max-w-lg flex-col items-center justify-center gap-y-4">
        <Heading level={2}>
          Unikke filtre der matcher din målgruppe perfekt
        </Heading>
        <p className="text-center text-sm leading-6 font-medium text-neutral-400">
          Lav dine egne filtre - baseret på AI og indhold på firmaets hjemmeside
          - og find firmaer der skal bruge præcis dét du sælger.
          <br />
          <br />
          Vil du f.eks. kunne finde Gazelle virksomheder, eller virksomheder som
          har en webshop eller som er ISO certificerede?
          <br />
          <br />
          Kun fantasien sætter grænsen!
        </p>
        <div className="mt-auto flex flex-col items-center">
          <Button
            className="mt-8 mb-5"
            size="lg"
            onPress={postContactInfo}
            animate
          >
            Kontakt mig
          </Button>
          <p className="text-xs font-medium text-neutral-400">
            Eller ring på +45 71 74 78 12
          </p>
        </div>
      </div>
    </div>
  );
};
